/* eslint-disable import/no-named-as-default-member */
/* eslint-disable @typescript-eslint/no-explicit-any */
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import * as Yup from 'yup'

import { commonSchema } from './common'
import { TSHIRT_SIZES } from '../../../constants/models'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Manila')
dayjs.extend(customParseFormat)

const validateJerseyField = (value: any, testContext: any) => {
  if (testContext.parent.hasJersey)
    if (value !== undefined && value !== null) {
      return value && value.toString().trim().length > 0
    } else return false

  return true
}

const IndividualUserSchema = Yup.object().shape({
  ...commonSchema,
  email: Yup.string()
    .email('Email Address must be a valid email')
    .required('Email Address is required'),
  confirmEmail: Yup.string()
    .email('Confirm Email Address must be a valid email')
    .required('Confirm Email Address is required')
    .oneOf([Yup.ref('email'), null], 'Email addresses must match'),
  confirmPhoneNumber: Yup.string()
    .required('Confirm phone number is required')
    .oneOf([Yup.ref('phoneNumber'), null], 'Phone numbers must match'),

  confirmEmergencyContactPhone: Yup.string()
    .required('Confirm Emergency Contact Number is required')
    .oneOf(
      [Yup.ref('emergencyContactPhone'), null],
      'Emergency Contact Numbers must match',
    ),

  // bike jersey
  hasJersey: Yup.boolean(),
  jerseySize: Yup.mixed()
    .test('required-with-hasJersey', 'Jersey is required', validateJerseyField)
    .oneOf(Object.keys(TSHIRT_SIZES)),
})

export default IndividualUserSchema
